export const customersData = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    email: 'rajesh.kumar@gmail.com',
    phone: '+91 98765 43210',
    address: '123 MG Road, Bangalore, Karnataka 560001',
    joinDate: '2023-08-15',
    totalOrders: 12,
    totalSpent: 269501, // ₹2,69,501
    status: 'Active',
    lastOrder: '2024-01-15',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-001', date: '2024-01-15', amount: 107817, status: 'Completed' },
      { id: 'ORD-015', date: '2023-12-20', amount: 59999, status: 'Completed' },
      { id: 'ORD-028', date: '2023-11-10', amount: 24999, status: 'Completed' }
    ]
  },
  {
    id: 2,
    name: 'Priya Sharma',
    email: 'priya.sharma@gmail.com',
    phone: '+91 87654 32109',
    address: '456 CP Road, Mumbai, Maharashtra 400001',
    joinDate: '2023-06-22',
    totalOrders: 8,
    totalSpent: 178948, // ₹1,78,948
    status: 'Active',
    lastOrder: '2024-01-14',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-002', date: '2024-01-14', amount: 110666, status: 'Pending' },
      { id: 'ORD-019', date: '2023-12-05', amount: 68248, status: 'Completed' }
    ]
  },
  {
    id: 3,
    name: 'Amit Patel',
    email: 'amit.patel@gmail.com',
    phone: '+91 76543 21098',
    address: '789 SG Highway, Ahmedabad, Gujarat 380001',
    joinDate: '2023-09-10',
    totalOrders: 15,
    totalSpent: 375409, // ₹3,75,409
    status: 'Active',
    lastOrder: '2024-01-14',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-003', date: '2024-01-14', amount: 49717, status: 'Completed' },
      { id: 'ORD-022', date: '2023-12-28', amount: 89999, status: 'Completed' }
    ]
  },
  {
    id: 4,
    name: 'Sneha Gupta',
    email: 'sneha.gupta@gmail.com',
    phone: '+91 65432 10987',
    address: '321 Sector 18, Noida, Uttar Pradesh 201301',
    joinDate: '2023-11-03',
    totalOrders: 6,
    totalSpent: 153301, // ₹1,53,301
    status: 'Active',
    lastOrder: '2024-01-13',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-004', date: '2024-01-13', amount: 65999, status: 'Completed' },
      { id: 'ORD-031', date: '2023-12-15', amount: 87302, status: 'Completed' }
    ]
  },
  {
    id: 5,
    name: 'Vikram Singh',
    email: 'vikram.singh@gmail.com',
    phone: '+91 54321 09876',
    address: '654 Civil Lines, Delhi, Delhi 110001',
    joinDate: '2023-07-18',
    totalOrders: 3,
    totalSpent: 103584, // ₹1,03,584
    status: 'Inactive',
    lastOrder: '2023-10-22',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-005', date: '2024-01-13', amount: 41999, status: 'Canceled' },
      { id: 'ORD-018', date: '2023-10-22', amount: 61585, status: 'Completed' }
    ]
  },
  {
    id: 6,
    name: 'Kavya Reddy',
    email: 'kavya.reddy@gmail.com',
    phone: '+91 43210 98765',
    address: '987 Banjara Hills, Hyderabad, Telangana 500001',
    joinDate: '2023-05-14',
    totalOrders: 18,
    totalSpent: 517422, // ₹5,17,422
    status: 'VIP',
    lastOrder: '2024-01-12',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-006', date: '2024-01-12', amount: 25999, status: 'Pending' },
      { id: 'ORD-025', date: '2023-12-30', amount: 132717, status: 'Completed' }
    ]
  },
  {
    id: 7,
    name: 'Arjun Mehta',
    email: 'arjun.mehta@gmail.com',
    phone: '+91 32109 87654',
    address: '147 Park Street, Kolkata, West Bengal 700001',
    joinDate: '2023-04-08',
    totalOrders: 22,
    totalSpent: 701848, // ₹7,01,848
    status: 'VIP',
    lastOrder: '2024-01-12',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-007', date: '2024-01-12', amount: 68998, status: 'Completed' },
      { id: 'ORD-029', date: '2023-12-18', amount: 182517, status: 'Completed' }
    ]
  },
  {
    id: 8,
    name: 'Ananya Joshi',
    email: 'ananya.joshi@gmail.com',
    phone: '+91 21098 76543',
    address: '258 FC Road, Pune, Maharashtra 411001',
    joinDate: '2023-10-25',
    totalOrders: 9,
    totalSpent: 236301, // ₹2,36,301
    status: 'Active',
    lastOrder: '2024-01-11',
    avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&h=100&fit=crop&crop=face',
    orderHistory: [
      { id: 'ORD-008', date: '2024-01-11', amount: 29999, status: 'Completed' },
      { id: 'ORD-033', date: '2023-12-08', amount: 53867, status: 'Completed' }
    ]
  }
];

export const customerStatuses = ['Active', 'Inactive', 'VIP', 'Blocked'];